// Passes are in limited beta. Only these companies see the surface: the
// sidebar nav item and the /purchases/passes route. To roll out to everyone,
// widen or remove this allowlist (single source of truth — don't hardcode the
// ids elsewhere).
export const PASSES_BETA_COMPANY_IDS = [7];

/**
 * True when the signed-in company is in the passes beta. Reads the company
 * id from localStorage (same key the rest of the app uses). Defaults to false
 * on any parse issue so the feature stays hidden by default.
 */
export function isPassesBetaCompany() {
  try {
    const id = Number(localStorage.getItem('companyId'));
    return PASSES_BETA_COMPANY_IDS.includes(id);
  } catch (e) {
    return false;
  }
}
